import { render, staticRenderFns } from "./DossierScriptEditStructureArgument.vue?vue&type=template&id=40f56c84&scoped=true&"
import script from "./DossierScriptEditStructureArgument.vue?vue&type=script&lang=ts&"
export * from "./DossierScriptEditStructureArgument.vue?vue&type=script&lang=ts&"
import style0 from "./DossierScriptEditStructureArgument.vue?vue&type=style&index=0&id=40f56c84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f56c84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40f56c84')) {
      api.createRecord('40f56c84', component.options)
    } else {
      api.reload('40f56c84', component.options)
    }
    module.hot.accept("./DossierScriptEditStructureArgument.vue?vue&type=template&id=40f56c84&scoped=true&", function () {
      api.rerender('40f56c84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dossier/DossierScriptEditStructureArgument.vue"
export default component.exports